import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supportedLngs } from '../../i18n/config';
import './LanguageSwitcher.css';

export const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('i18nextLng', lng);
    setIsOpen(false);
  };

  const getCurrentLanguageName = () => {
    return supportedLngs[i18n.language as keyof typeof supportedLngs] || supportedLngs.en;
  };

  const getLanguageFlag = (lng: string) => {
    if (lng === 'eu') {
      return <img className="language-flag-image" src="/flags/eu.svg" alt="" />;
    }
    const flags: Record<string, string> = {
      en: '🇬🇧',
      es: '🇪🇸', 
      eu: '🏴󠁥󠁳󠁰󠁶󠁿'
    };
    return flags[lng] || '🌐';
  };

  return (
    <div className="language-switcher">
      <button 
        className="language-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('changeLanguage')}
      >
        <span className="language-flag">{getLanguageFlag(i18n.language)}</span>
        <span className="language-name">{getCurrentLanguageName()}</span>
        <span className={`language-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {Object.entries(supportedLngs).map(([code, name]) => (
            <button
              key={code}
              className={`language-option ${i18n.language === code ? 'active' : ''}`}
              onClick={() => handleLanguageChange(code)}
            >
              <span className="language-flag">{getLanguageFlag(code)}</span>
              <span className="language-name">{name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};